let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Nndp")).then(() => parcelRequire('k3jgm'));